<template>
    <div class="help-center-content">
        <h4>数据分析</h4>
        <p class="title">1.	什么是节目推荐指数？</p>
        <p class="content">喜马拉雅FM的节目推荐，采用的是智能算法。而哪个节目被推荐的更多？曝光给多少用户？则取决于节目的推荐指数。推荐指数越高，在榜单、分类排名、猜你喜欢、搜索等方面就会被更多地曝光。
            <br><br><strong>推荐指数主要由以下五个维度构成：</strong><br>
            1.	<strong>播放人数</strong>：最近一周被多少人播放<br>
            2.	<strong>完播率</strong>：节目被完整播放的比例<br>
            3.	<strong>跳出率</strong>：用户在某段时间终止播放<br>
            4.	<strong>留存率</strong>：两周后还有多少人在听<br>
            5.	<strong>订阅量</strong>：月度新增的订阅用户
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_1.png`" style="width: 294px; height: 220px;">
        <p class="content">举个栗子小明的节目《小红说》最新数据如下：<br>
            最近7天完播人数：<strong>20000</strong><br>
            最近7天节目完播率：<strong>50%</strong><br>
            最近7天节目跳出率：<strong>30%</strong><br>
            最近14天节目留存率：<strong>20%</strong><br>
            最近30天新增订阅量：<strong>3000</strong><br><br>
            那么《小红说》的节目推荐指数约等于：83分，全站排名前50，是不是已经非常棒了。
        </p>
        <p class="title">2. 如何增加播放人数？</p>
        <p class="content"><strong>增加订阅量提升播放人数</strong><br>
            拥有更多粉丝与订阅才能带来长期稳定的播放量。您可以在节目中提示听众点击”订阅“按钮订阅您的专辑哦，也可以分享节目给您的朋友们“求订阅”！
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_2.png`" style="width: 330px;height: 200px;">
        <p class="content"><strong>新节目上线立即分享</strong><br>
            当你的节目通过审核，收到提醒，此时是不是已经迫不及待地要与你的好友或者粉丝分享你的声音作品了呢？那就立刻分享到 微博、微信、QQ空间等，获取第一批高播放量。
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_3.png`"  style="width: 460px;height: 190px;">
        <p class="title">3. 如何提升节目完播率？</p>
        <p class="content"><strong>节目完播率就是说完整的听完整档节目的人数比例，节目不仅要让你的听众一见钟情，还要实实在在的长情。所以不能虎头蛇尾哦，一定要整档节目都能把你的听众吸引住哦。</strong>
            <br><br><strong>要在最短时间抓住听众耳朵</strong>
            <br>节目抓不抓耳，开头很重要。只有当音人声完美地结合时，能为节目起到锦上添花、画龙点睛的作用。节目开头引领听众走入丰富的节目中。一定要在1分钟内打动听众。想要打动听众，自己必须对节目有一个明晰的意境，定位准确。
            <br><br><strong>表达要有趣（生动鲜活）</strong>
            <br>大多数人聊严肃类话题都是很无趣的，我不信你们上历史政治化学物理数学课没有打过瞌睡！深入浅出、生动有趣、一语中的的犀利表达一定会吸引听众的。
            <br>喜闻乐见：有趣，吐槽，别人比我惨……
            <br>有我：帮自己定义一个风格，例如，我是一个好人，有B格，有品位，有意思，有正义感……
            <br>有用：独特的视角，方法论，前因后果，细节
        </p>
        <p class="title">4. 如何降低节目跳出率？</p>
        <p class="content"><strong>你了解自己的节目跳出率吗？</strong><br>
            一个节目如果有20分钟时间，我们会把它切成100份，这样我们就可以知道用户在收听的时候，在什么时间点跳出离开。主播有了这个数据，就可以对自己的节目进行优化。每个认证主播都可以在自己的数据中心查阅跳出率。
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_4.png`"  style="width: 524px;height: 290px">
        <p class="content"><strong>通过跳出率发现问题，改善节目。</strong><br>
            很多节目，听众在1分钟不到的时候就跑了，这些节目的片花就有1分多钟长。所以我们建议主播片花可以做得短一点。主播可以经常去研究节目中高跳出率的部分，听众究竟为什么从这里“跑掉了”。
        </p>
        <p class="title">5. 如何提升节目留存率？</p>
        <p class="content"><strong>什么是节目留存率？</strong><br>
            打个比方，本周你新增了100个粉丝，那么试想一下，一周以后还有多少人继续听着你的节目？两周以后呢？同样是这批人，四周以后呢？所以留存率一定是好节目的重要标准之一，你的节目留存情况如何？如果不是很理想，那么就应该思考一下如何改进节目质量啦！
            <br><br>您可以在数据中心里查阅留存率：
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_5.png`"  style="width: 534px; height: 300px">
        <p class="content"><strong>增加订阅量提升播放人数</strong><br>
            拥有更多粉丝与订阅才能带来长期稳定的播放量。您可以在节目中提示听众点击”订阅“按钮订阅您的专辑哦，也可以分享节目给您的朋友们“求订阅”！
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_5.png`"  style="width: 330px;height: 200px;">
        <p class="content"><strong>通过合理的节目更新周期提升留存率</strong>
            <br>要吸粉，要让听众持续的关注你的节目，就得有尽量固定的更新频率与周期，就像卖东西，要想销量好，客户总得知道你什么时候开张，什么时候打烊。
            <br><br><strong>通过更多的分享传播提升留存率</strong>
            <br>分享出去，让自己的节目赢得更多粉丝吧！利用好你在其他网站的影响力。不浪费，全部用上。调动现有粉丝，让大家把你节目分享出去，获得更多人的关注，说不定，一大波新粉正在靠近呢。
            <br><br><strong>勤回复，多互动，增加忠实粉丝</strong>
            <br>符合三观的，有趣，有益的，经常互动，并回粉。回复评论与粉丝互动啊，这是一开始最有效最务实的方法，不要多考虑，直接上。努力吧，幸福总在下一个拐角。可以偶尔在节目中读出以往节目中的留言，还可以事先设定一个话题，让大家来留言互动。让你与听众走的更近一些吧。
        </p>

        <p class="title">6. 如何增加节目订阅量？</p>
        <p class="content"><strong>要记得常常和听众互动哟</strong><br>
            沉默永远是关注度的最大杀手！

            <br><br><strong>勤回复：</strong>
            <br>符合三观的，有趣，有益的，经常互动，并回粉。回复评论与粉丝互动啊，这是一开始最有效最务实的方法，不要多考虑，直接上。努力吧，幸福总在下一个拐角。
            <br><br><strong>线上互动：</strong>
            <br>可以偶尔在节目中读出以往节目中的留言，还可以事先设定一个话题，让大家来留言。安抚人心。
            <br><br><strong>给他人点赞和评论：</strong>
            <br>点赞和评论是沟通，要有针对性。也不能瞎点，要按兴趣。在自己已经粉的高手里，点赞和沟通。这样不仅可以交到更多的主播朋友还可能吸引更多的粉丝哦。
            <br><br><strong>分享传播也很重要</strong>
            <br>分享出去，让自己的节目赢得更多粉丝吧！利用好你在其他网站的影响力。不浪费，全部用上。调动现有粉丝，让大家把你节目分享出去，获得更多人的关注，说不定，一大波新粉正在靠近呢。
            <br><br><strong>提醒你的听众点击“订阅节目”</strong>
            <br>粉丝很多，订阅很少？不如在你的节目中提示听众点击“订阅节目”按钮，为你增加订阅量。
        </p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      }
    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// DataAnalysis.vue?5013df37